import { apiService } from './index';

// Inport types
import { IDocumentType } from '../shared/types/document-type';

export const asyncGetDocumentTypes = async (): Promise<IDocumentType[]> => {
    const { items }: any = await apiService.get(`/api/document-type`);
    return items || [];
};

export const asyncGetDocumentTypeByCode = async (
    code: string
): Promise<IDocumentType> => {
    const { items }: any = await apiService.get(
        `/api/document-type/by-code/${code}`
    );
    return items;
};
